import { shiftEditorViewState } from "..";
import { mutatorAction } from "satcheljs";

export default mutatorAction("updateBusyDeleting", function updateBusyDeleting(isBusy: boolean) {
    shiftEditorViewState().busyDeleting = isBusy;
});